import { type IssueViewSection, ISSUE_VIEW_SECTION } from './IssueViewSection.types.tsx';

export const isDeliverySection = (section?: IssueViewSection | string): boolean => {
	if (!section) {
		return false;
	}

	return (
		section === ISSUE_VIEW_SECTION.DELIVER_CREATE ||
		section === ISSUE_VIEW_SECTION.DELIVER_LINK ||
		section === ISSUE_VIEW_SECTION.DELIVER
	);
};
